import React, { memo } from 'react';
import {
  FormPageInputItemTextName,
  TextNameInput,
  TextPropertyName,
  mappedConst,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type Props = FormFieldInputItemProps<
  TextPropertyName,
  FormPageInputItemTextName
> & {
  firstName: FormPageInputItemTextName['firstName'];
  lastName: FormPageInputItemTextName['lastName'];
};
type UpdateKey = keyof Pick<
  FormPageInputItemTextName,
  'firstName' | 'lastName'
>;
const UPDATE_KEY: mappedConst<UpdateKey> = {
  firstName: 'firstName',
  lastName: 'lastName',
};

export const TextName: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    firstName: firstNameValue,
    lastName: lastNameValue,
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
    reEnter,
  }) => {
    const { propertyId, inputFormat } = property;
    const { firstName, lastName } = inputFormat;
    const createChangeHandler = (key: UpdateKey) => (inputData: string) => {
      onChange(key, inputData);
    };
    const createBlurHandler = (key: UpdateKey) => (inputData: string) => {
      onBlur(key, inputData);
    };

    return (
      <TextNameInput
        propertyId={propertyId}
        firstNamePlaceholder={reEnter ? '' : firstName.placeholder}
        lastNamePlaceholder={reEnter ? '' : lastName.placeholder}
        firstNameLabel={firstName.label}
        lastNameLabel={lastName.label}
        firstName={firstNameValue}
        lastName={lastNameValue}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onFirstNameChange={createChangeHandler(UPDATE_KEY.firstName)}
        onLastNameChange={createChangeHandler(UPDATE_KEY.lastName)}
        onFirstNameBlur={createBlurHandler(UPDATE_KEY.firstName)}
        onLastNameBlur={createBlurHandler(UPDATE_KEY.lastName)}
        design={design}
        className={className}
      />
    );
  }
);
